import React from 'react';
import JournalDumbView from '../../../DeviationViews/Dumbo/Journal';
import { Props } from '../InlineView';

import s from './Journal.scss';

const JournalThumbReactView: React.FC<Props> = props => (
  <div className={s['root']} style={{ width: props.width, height: props.height }}>
    <JournalDumbView {...props} />
  </div>
);
JournalThumbReactView.displayName = 'JournalThumbReactView';

export default JournalThumbReactView;
